module.exports = {
  "dof-popup": {
    "position": "fixed",
    "zIndex": 1000
  },
  "top": {
    "left": 0,
    "right": 0
  },
  "bottom": {
    "left": 0,
    "right": 0
  },
  "left": {
    "bottom": 0,
    "top": 0
  },
  "right": {
    "bottom": 0,
    "top": 0
  },
  "midea-actionsheet-bottom": {
    "height": "100",
    "flexDirection": "row",
    "justifyContent": "space-between"
  },
  "midea-actionsheet-btn": {
    "fontSize": "32",
    "backgroundColor": "#ffffff",
    "lineHeight": "100",
    "textAlign": "center",
    "flex": 1,
    "backgroundColor:active": "#f5f5f5"
  },
  "leftBtn": {
    "color": "#616C73",
    "borderRightColor": "#e5e5e5",
    "borderRightWidth": "1",
    "borderRightStyle": "solid"
  },
  "rightBtn": {
    "color": "#00A4F2"
  },
  "btnGap": {
    "backgroundColor": "#f3f3f3"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-63c3b709!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-popup/index.vue
// module id = 501
// module chunks = 0 1